import React, { lazy } from 'react'
import { Route } from 'react-router-dom'

const Checkout = lazy(() => import('../modules/Checkout'))

/**
 * Sits under `AuthorizedLayout` on purpose: `RequireAuth` is what holds an
 * unverified account on the verification screen until the address is
 * confirmed, and this route is the thing waiting on the other side of it.
 */
export const checkoutRoutes = [
  <Route key='checkout' path='/checkout' element={<Checkout />} />
]
